<section
  [ngStyle]="cssClass"
  (mouseout)="calculateColumnsContainer()"
  (mouseover)="calculateHoverColumnsContainer()"
  class="row-container"
  [class.mat-elevation-z2]="isHover"
  #content
>
  <ng-content> </ng-content>
</section>
